import {isRTL} from '../../../Localization';

export const supportUrl = 'https://support.priority-software.com/';

export enum PurchasePlanningPromoText {
    title = 'title',
    bodyP1 = 'bodyP1',
    menuName = 'menuName',
    bodyP2 = 'bodyP2',
    learnMoreBtn = 'learnMoreBtn',
    linkSuffix = 'linkSuffix',
    acceptBtn = 'acceptBtn'
}

const en = {
    title: 'Your New Planning Menu',
    bodyP1: "We've added a new",
    menuName: 'Planning',
    bodyP2: 'menu containing all menus related to MRP and purchase planning programs, forecasts, and ATP – now in a more centralized and simpler format.',
    learnMoreBtn: 'Learn more',
    linkSuffix: 'en/kb/LBI2500492/English',
    acceptBtn: 'OK, got it'
};

const he = {
    title: 'תפריט תכנון חדש',
    bodyP1: 'הוספנו תפריט',
    menuName: 'תכנון',
    bodyP2: 'חדש ובו כל התפריטים הנוגעים לתוכניות תכנון תחזיות ו- ATP, עכשיו בצורה מרוכזת ופשוטה יותר.',
    learnMoreBtn: 'למידע נוסף',
    linkSuffix: 'he/kb/LBI2500491/Hebrew',
    acceptBtn: 'הבנתי'
};

export const getHardcodedText = (key: PurchasePlanningPromoText): string => {
    return isRTL() ? he[key] : en[key];
};

export const getLearnMoreUrl = () => {
    return supportUrl + getHardcodedText(PurchasePlanningPromoText.linkSuffix);
};
